import SnackBarPayload from '../components/custom-controls/snackbar-wrapper/snack-bar-payload';

const dispatchSnackbar = (snackBarPayload: SnackBarPayload) => {
	window.sessionStorage.setItem('snackbar-storage', JSON.stringify(snackBarPayload));
	window.dispatchEvent(new Event('snackbar-storage-event'));
};

export default dispatchSnackbar;
